<template>
  <IconButtonV2
    :id="intercomLauncherId"
    type="button"
    :aria-label="$t('services.intercom.launcher')"
    icon="material-symbols:contact-support-rounded"
    :disabled="!intercomService?.initialized"
    :is-active="variant === 'primary'"
    size="xl"
    @click="onClick"
  />
</template>

<script setup lang="ts">
import { intercomLauncherId } from "@/services/tracking/intercom-service";
import { useIntercomService } from "@/stores/tracking/use-intercom-service";
import IconButtonV2 from "@/components/ui/button/icon-button-v2.vue";

const intercomService = useIntercomService();

defineProps<{
  variant: "primary" | "secondary";
}>();

const onClick = () => {
  intercomService.value?.trigger();
};
</script>
